"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const cloneUtils_1 = require("../cloneUtils");
// Unsupported on purpose: the configuration is a snapshot of the source org's
// borrowerConfig and creditFacilityConfigs, which a template clone into another
// org can't carry over.
exports.cloneFromTemplateArtifact = cloneUtils_1.unSupportedClone;
//# sourceMappingURL=clone.js.map